import type { FC } from 'react';
import React from 'react';

import type { TDcFormShort } from '../../models';

type TMobileIdDisabledInput = Pick<TDcFormShort, 'mobileIdDisabled'>;

export const MobileIdDisabledInput: FC<TMobileIdDisabledInput> = ({ mobileIdDisabled }) => {
    if (!mobileIdDisabled) return null;

    return (
        <input
            data-test-id="mobile-id-disabled-input"
            name="mobileIdDisabled"
            type="hidden"
            value="true"
        />
    );
};
